import {
  Box,
  Button,
  IconButton,
  InputAdornment,
  TextField,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import signupImage from "../images/signup.png";
import axios from "axios";
import { API_URL } from "../components/Constant";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import Colors from "../components/Colors";

function RapidRiddleSignIn() {
  const [name, setName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [countryCode, setCountryCode] = useState("+91");
  const [nameError, setNameError] = useState("");
  const [phoneNumberError, setPhoneNumberError] = useState("");
  const [countryCodeError, setCountryCodeError] = useState("");
  const [password, setPassword] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [signinError, setSigninError] = useState("");

  const handleCountryCodeChange = (e) => {
    let newValue = e.target.value;
    if (/^\+?\d*$/.test(newValue)) {
      if (newValue.length <= 4) {
        setCountryCode(newValue);
      }
    }
    setCountryCodeError("");
    setPhoneNumberError("");
    setSigninError("");
  };

  const handlePhoneChange = (e) => {
    const newValue = e.target.value;
    if (/^\d*$/.test(newValue) && newValue.length <= 10) {
      setPhoneNumber(newValue);
    }
    setPhoneNumberError("");
    setCountryCodeError("");
    setSigninError("");
  };

  const handlePasswordChange = (event) => {
    setPassword(event.target.value);
    setPasswordError("");
    setSigninError("");
  };
  const handleNameChange = (e) => {
    setName(e.target.value);
    setNameError("");
    setSigninError("");
  };
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleForgotPasswordClick = async () => {
    window.location.href = "/forgot-password";
    localStorage.setItem("forgotcountry", countryCode);
    localStorage.setItem("forgotphone", phoneNumber);
    localStorage.setItem("forgotname", name);
  };
  const sanitizeName = (name) => name.trim();
  // Handle form submission (Register button click)
  const handleSignIn = async () => {
    const country = countryCode.replace(/^\+/, "");
    const playerName = sanitizeName(name);
    if (name.trim() === "") {
      setNameError("Please enter your name");
    }

    if (country.trim() === "") {
      setCountryCodeError("Please enter your country code");
    } else if (phoneNumber.trim() === "") {
      setPhoneNumberError("Please enter your phone number");
    } else if (password.trim() === "") {
      setPasswordError("Please enter your password");
    } else {
      try {
        const response = await axios.post(
          `${API_URL}/select_rapid_riddle_player_details`,
          {
            name: playerName,
            countryCode: country,
            phone: phoneNumber,
            password: password,
          },
        );
        console.log("sign in", response.data.error);
        setSigninError(response.data.error);
        if (response.data.success === true) {
          localStorage.setItem("PlayerTocken", response.data.token);
          window.location.href = "/home";
        }
      } catch (error) {
        console.error("something went wrong", error);
      }
    }
  };

  const handleSignUpButtonClick = () => {
    window.location.href = "/rapid-signup";
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        background: Colors.bgColor,
        width: "100%",
        height: "100vh",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          background: "white",
          width: "100%",
          height: "100%",
          justifyContent: "center",
          alignItems: "center",
          maxWidth: { md: "70%", xs: "90%" },
          maxHeight: { md: "70%", xs: "60%" },
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            width: "100%",
            height: "100%",
            gap: "32px",
            justifyContent: "center",
            alignItems: "center",
            maxWidth: { md: "95%", xs: "90%" },
            maxHeight: "90%",
          }}
        >
          <Box
            sx={{
              display: { md: "flex", xs: "none" },
              flexDirection: "row",
              width: "50%",
              height: "100%",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <img
              src={signupImage}
              alt="signup"
              style={{ width: "100%", height: "100%", objectFit: "100% 100%" }}
            />
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              width: { md: "50%", xs: "100%" },
              height: "100%",
              justifyContent: "center",
              alignItems: "center",
              gap: "16px",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                width: "100%",
                height: "fit-content",
                justifyContent: "center",
                alignItems: "center",
                gap: "16px",
              }}
            >
              <Typography
                sx={{
                  fontFamily: "Roboto",
                  fontSize: "36px",
                  fontWeight: 600,
                  color: Colors.Tidesfont,
                }}
              >
                Welcome!
              </Typography>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  width: "100%",
                  height: "fit-content",
                  justifyContent: "center",
                  alignItems: "flex-start",
                  gap: "4px",
                }}
              >
                <Typography
                  sx={{
                    fontFamily: "Roboto",
                    fontSize: { xs: "12px", md: "14px" },
                    fontWeight: 400,
                  }}
                >
                  Nick name:
                </Typography>
                <TextField
                  value={name}
                  onChange={handleNameChange}
                  fullWidth
                  inputProps={{
                    sx: {
                      height: { md: "32px", xs: "28px" },
                      padding: "4px 10px",
                      fontSize: { md: "14px", xs: "12px" },
                    },
                  }}
                  sx={{
                    borderRadius: "8px",
                  }}
                />
                {nameError && (
                  <Typography
                    sx={{
                      color: "red",
                      fontFamily: "Roboto",
                      fontSize: { xs: "12px", md: "14px" },
                      fontWeight: 400,
                    }}
                  >
                    {nameError}
                  </Typography>
                )}
              </Box>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  width: "100%",
                  height: "fit-content",
                  justifyContent: "flex-start",
                  alignItems: "flex-start",
                  gap: "8px",
                }}
              >
                <Box
                  sx={{ width: { md: "20%", xs: "35%" }, minWidth: "100px" }}
                >
                  <Typography
                    sx={{
                      fontFamily: "Roboto",
                      fontSize: { xs: "12px", md: "14px" },
                      fontWeight: 400,
                    }}
                  >
                    Country code:
                  </Typography>
                  <TextField
                    value={countryCode}
                    onChange={handleCountryCodeChange}
                    variant="outlined"
                    fullWidth
                    inputProps={{
                      sx: {
                        height: { md: "32px", xs: "28px" },
                        padding: "4px 10px",
                        fontSize: { md: "14px", xs: "12px" },
                      },
                    }}
                    sx={{ borderRadius: "8px" }}
                  />
                </Box>
                <Box sx={{ width: { md: "80%", xs: "65%" } }}>
                  <Typography
                    sx={{
                      fontFamily: "Roboto",
                      fontSize: { xs: "12px", md: "14px" },
                      fontWeight: 400,
                    }}
                  >
                    Phone number:
                  </Typography>
                  <TextField
                    value={phoneNumber}
                    onChange={handlePhoneChange}
                    variant="outlined"
                    fullWidth
                    inputProps={{
                      sx: {
                        height: { md: "32px", xs: "28px" },
                        padding: "4px 10px",
                        fontSize: { md: "14px", xs: "12px" },
                      },
                    }}
                    sx={{ borderRadius: "8px" }}
                  />
                </Box>
              </Box>
              {countryCodeError && (
                <Typography
                  sx={{
                    color: "red",
                    fontFamily: "Roboto",
                    fontSize: { xs: "12px", md: "14px" },
                    fontWeight: 400,
                  }}
                >
                  {countryCodeError}
                </Typography>
              )}
              {phoneNumberError && (
                <Typography
                  sx={{
                    color: "red",
                    fontFamily: "Roboto",
                    fontSize: { xs: "12px", md: "14px" },
                    fontWeight: 400,
                  }}
                >
                  {phoneNumberError}
                </Typography>
              )}

              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  width: "100%",
                  height: "fit-content",
                  justifyContent: "center",
                  alignItems: "flex-start",
                  gap: "4px",
                }}
              >
                <Typography
                  sx={{
                    fontFamily: "Roboto",
                    fontSize: { xs: "12px", md: "14px" },
                    fontWeight: 400,
                  }}
                >
                  Password:
                </Typography>
                <TextField
                  type={showPassword ? "text" : "password"}
                  value={password}
                  onChange={handlePasswordChange}
                  fullWidth
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={togglePasswordVisibility}
                          edge="end"
                          aria-label="toggle password visibility"
                          color="primary"
                        >
                          {showPassword ? (
                            <VisibilityOutlinedIcon
                              sx={{
                                color: "#313131",
                                fontSize: { md: "18px", xs: "12px" },
                              }}
                            />
                          ) : (
                            <VisibilityOffOutlinedIcon
                              sx={{
                                color: "#313131",
                                fontSize: { md: "18px", xs: "12px" },
                              }}
                            />
                          )}
                        </IconButton>
                      </InputAdornment>
                    ),
                    sx: {
                      height: { md: "41px", xs: "34px" },
                      padding: "4px 10px 4px 0px",
                      fontSize: { md: "14px", xs: "12px" },
                    },
                  }}
                  sx={{
                    borderRadius: "8px",
                  }}
                />

                {passwordError && (
                  <Typography
                    sx={{
                      color: "red",
                      fontFamily: "Roboto",
                      fontSize: { xs: "12px", md: "14px" },
                      fontWeight: 400,
                    }}
                  >
                    {passwordError}
                  </Typography>
                )}
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Typography
                    component="span"
                    sx={{
                      color: Colors.button1,
                      fontSize: { xs: "10px", md: "14px" },
                      cursor: "pointer",
                    }}
                    onClick={handleForgotPasswordClick}
                  >
                    Forgot password?
                  </Typography>
                </Box>
              </Box>

              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  width: "100%",
                  height: "100%",
                  justifyContent: "flex-start",
                  alignItems: "flex-start",
                  gap: "8px",
                  marginTop: { md: "24px", xs: "16px" },
                }}
              >
                <Button
                  onClick={handleSignIn}
                  sx={{
                    background: Colors.button1,
                    color: "#fff",
                    height: { md: "36px", xs: "32px" },
                    width: "100%",
                    border: "1px solid",
                    borderColor: Colors.button1,
                    borderRadius: "8px",
                    cursor: "pointer",
                    fontSize: "12px",
                    transition: "background 0.3s, transform 0.3s",
                    "&:hover": {
                      background: Colors.button1,
                      transform: "scaleY(1.05)",
                    },
                    "&:active": {
                      background: Colors.button1,
                    },
                  }}
                >
                  Sign in
                </Button>

                {signinError && (
                  <Typography
                    sx={{
                      color: "red",
                      fontFamily: "Roboto",
                      fontSize: { xs: "12px", md: "14px" },
                      fontWeight: 400,
                    }}
                  >
                    {signinError}
                  </Typography>
                )}
              </Box>

              <Typography sx={{ fontSize: { xs: "12px", md: "16px" } }}>
                Don’t have an account?
                <Typography
                  component="span"
                  sx={{
                    color: Colors.button2,
                    display: "inline",
                    marginLeft: { xs: "4px", md: "8px" },
                    fontSize: { xs: "12px", md: "16px" },
                    cursor: "pointer",
                  }}
                  onClick={handleSignUpButtonClick}
                >
                  Create Account
                </Typography>
              </Typography>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

export default RapidRiddleSignIn;
